// 基础资料-仓库列表
export const search = {
  inputs: [
    // 信息列数不多，故不要筛选项区域
  ],
  lines: [
    {
      prop: 'code',
      label: 'Warehouse ID',
      width: 120
    },
    {
      prop: 'name',
      label: 'Warehouse Name',
      width: 200
    },
    {
      prop: 'address',
      label: 'Address',
      width: 400
    },
    {
      prop: 'is_calc_for_csr_order',
      label: 'Calc for CSR-order',
      width: 160
    },
    {
      prop: 'created_at',
      label: 'Create Date',
      width: 130
    },
    {
      prop: 'updated_at',
      label: 'Modify Date',
      width: 130
    }
    // 仓库资料不需要点击详情进行查看操作，因为信息量少。
  ]
}
// 不提供编辑页面、新增页面。仓库编辑的几率几乎没有。新增则在数据库中操作（几率极低）
export default { search }
